const TONES = {
  emerald: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  amber: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  blue: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  red: "bg-red-500/10 text-red-400 border-red-500/20",
  zinc: "bg-white/[0.05] text-muted-foreground border-border/40",
};

// Covers deposit, withdrawal, mt5 account, registration and transfer statuses.
const STATUS_TONE = {
  PENDING: "amber",
  RECEIVED: "blue",
  SETTLED: "emerald",
  ACTIVE: "emerald",
  IN_REVIEW: "amber",
  VERIFIED: "emerald",
  APPROVED: "emerald",
  REJECTED: "amber",
  REFUSED: "red",
  REGISTERED: "emerald",
  FAILED: "red",
  CANCELLED: "zinc",
  CLOSED: "zinc",
  NONE: "zinc",
  // Forex transfer history: reversed left the user whole, stranded did not.
  COMPLETED: "emerald",
  REVERSED: "amber",
  STRANDED: "red",
};

export function StatusBadge({ status }) {
  if (!status) return <span className="text-muted-foreground">—</span>;
  const tone = TONES[STATUS_TONE[status]] ?? TONES.zinc;
  return (
    <span
      className={`inline-flex rounded-full border px-2 py-0.5 text-xs font-medium ${tone}`}
    >
      {status}
    </span>
  );
}
